import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { Avatar } from "modules/avatar";
import { ICompany } from "modules/company/types";
import { IEvent } from "modules/event/types";
import { useStyles } from "./EventInfoStyles";

interface IEventTopBlockProps {
  event?: IEvent;
  company?: ICompany;
}

const EventTopBlock = ({ company, event }: IEventTopBlockProps) => {
  const { t } = useI18n(["common", "auth"]);
  const classes = useStyles();

  return (
    <div style={{ marginBottom: "40px" }}>
      <div style={{ textAlign: "center" }}>
        <Typography variant="h6" gutterBottom>
          {t("auth:today.event")}
        </Typography>
        <Typography variant="h3" gutterBottom>
          {event?.name}
        </Typography>
      </div>
      <div className="ev-speaker">
        <Avatar
          className={classes.eventLogoAvatar}
          pictureUrl={event?.logoURL}
        />
        {company && (
          <div className="ev-sk-name">
            <Typography variant="h6" gutterBottom data-testid="company-name">
              {t("by")}
              {company.name}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventTopBlock;
